export default __webpack_public_path__ + "static/media/ddsu5168_4p_rs485_master_4p.c7516fd6.png";